//#region src/components/Typography/Typography.module.css
var e = "_heading1_1om5p_1", t = "_heading1Fixed_1om5p_6", n = "_heading2_1om5p_20", r = "_heading3_1om5p_30", i = "_secondaryText_1om5p_42", a = "_accentText_1om5p_47", o = "_accentTextFixed_1om5p_52", s = "_smallText_1om5p_64", c = "_smallText_semibold_1om5p_71", l = "_semibold_1om5p_76", u = "_smallText_upper_1om5p_80", d = "_subtitle_1om5p_85", f = "_text_1om5p_92", p = "_text_italic_1om5p_99", m = "_monoText_1om5p_103", h = "_monoText_bold_1om5p_112", g = {
	heading1: e,
	heading1Fixed: t,
	heading2: n,
	heading3: r,
	secondaryText: i,
	accentText: a,
	accentTextFixed: o,
	smallText: s,
	smallText_semibold: c,
	semibold: l,
	smallText_upper: u,
	subtitle: d,
	text: f,
	text_italic: p,
	monoText: m,
	monoText_bold: h
};
//#endregion
export { a as accentText, o as accentTextFixed, g as default, e as heading1, t as heading1Fixed, n as heading2, r as heading3, m as monoText, h as monoText_bold, i as secondaryText, l as semibold, s as smallText, c as smallText_semibold, u as smallText_upper, d as subtitle, f as text, p as text_italic };
